@if (skillSet() && skillSet().spec) {
  <elder-pane class="full outlined">
    <elder-pane-header>
      <elder-pane-subtitle start>{{ 'skillSets.detail' | translate }}</elder-pane-subtitle>
    </elder-pane-header>
    <elder-pane-content>
      <div class="layout-col full">
        <div class="layout-row place-start-center gap-md pt-sm">
          <mat-form-field>
            <mat-label>{{ 'context.description' | translate }}</mat-label>
            <input
              matInput
              name="description"
              type="text"
              required
              placeholder="{{ 'context.description' | translate }}"
              [(ngModel)]="skillSet().description"
            />
            <mat-error elderValidationError></mat-error>
          </mat-form-field>
          <mat-form-field>
            <mat-label>{{ 'context.specification' | translate }}</mat-label>
            <input
              matInput
              name="specId"
              type="text"
              readonly
              placeholder="{{ 'context.specification' | translate }}"
              [(ngModel)]="skillSet().spec.name"
            />
          </mat-form-field>
        </div>
        <div class="flex layout-row gap-xl">
          <mat-tab-group class="flex" animationDuration="0ms">
            <!-- Tab conditions -->
            <mat-tab>
              <ng-template mat-tab-label>
                <span
                  class="noselect"
                  [matBadge]="skillSet()?.conditions?.length"
                  [matBadgeHidden]="!skillSet()?.conditions?.length"
                  [matBadgeOverlap]="false"
                  >{{ 'skillSets.conditions.title' | translate }}
                </span>
              </ng-template>
              <app-constraints-table
                class="flex"
                [name]="'conditions'"
                [tripleStateBoolean]="true"
                [constraints]="skillSet().conditions"
              >
              </app-constraints-table>
            </mat-tab>
            <!-- Tab Constraints -->
            <mat-tab>
              <ng-template mat-tab-label>
                <span
                  class="noselect"
                  [matBadge]="skillSet()?.constraints?.length"
                  [matBadgeHidden]="!skillSet()?.constraints?.length"
                  [matBadgeOverlap]="false"
                  >{{ 'skillSets.constraints.title' | translate }}
                </span>
              </ng-template>
              <app-constraints-table
                class="flex"
                [name]="'constraints'"
                [tripleStateBoolean]="true"
                [constraints]="skillSet().constraints"
              >
              </app-constraints-table>
            </mat-tab>
            <!-- Tab Capacities -->
            <mat-tab>
              <ng-template mat-tab-label>
                <span
                  class="noselect"
                  [matBadge]="skillSet()?.capacities?.length"
                  [matBadgeHidden]="!skillSet()?.capacities?.length"
                  [matBadgeOverlap]="false"
                  >{{ 'skillSets.capacities.title' | translate }}
                </span>
              </ng-template>
              <!-- TODO: fix wrong type being passed as variantSets (ProcessingTimeConf vs. ProcessingTime)-->
              <app-processing-time-variant-table
                class="flex"
                [name]="'capacities'"
                [variantSets]="skillSet().capacities"
              >
              </app-processing-time-variant-table>
            </mat-tab>
          </mat-tab-group>
        </div>
      </div>
    </elder-pane-content>
  </elder-pane>
}
